var PromocodesListView = (function (BaseView, GetPageTemplate, CheckoutSettings) {

    var VoucherView = BaseView.extend({
        className: 'gift-promocode__small',

        events: {
            'click @removePromocode': '_onClick'
        },

        initialize: function () {
            _.bindAll(this, '_render', '_remove');
            this.listenTo(this.model, 'remove', this._remove);
            this.listenTo(this.model, 'change', this._render);
            this._render();

            this._removeVoucherByKey = this.options.removeVoucherByKey;
            this._updateCheckout = this.options.updateCheckout;
        },

        _onClick: function (e) {
            var data = this.model.toJSON();
            e.preventDefault();
            data.Code && this._removeVoucherByKey(data.Code, CheckoutSettings.imageSize).done(this._updateCheckout);
        },

        _render: function () {
            var data = this.model.toJSON();
            if (data.Amount) {
                data.AmountStr = window.toMoney(data.Amount, GlobalSettings.CurrencySign);
            }
            this.$el.html($.tmpl('bt-checkout-promocode-item', data));
        },

        _remove: function () {
            this.remove();
        }
    });

    return BaseView.extend({

        hiddenBlock: 'hidden-block',

        el: '@promocodesContainer',

        initialize: function () {
            _.bindAll(this, '_render', '_update');
            this.listenTo(this.collection, 'add', this._render);
            this.listenTo(this.collection, 'update', this._update);
        },

        _render: function (model) {
            var voucher = new VoucherView({
                model: model,
                removeVoucherByKey: this.model.apiRemoveVoucherByKey,
                updateCheckout: this.model.updateCheckout
            });
            this.$el.append(voucher.$el);
        },

        _update: function () {
            this.$el.toggleClass(this.hiddenBlock, !this.collection.length);
        }
    });
})(BaseView, kos.getPageTemplate, CheckoutSettings);
